<script>
import _ from 'lodash'
import EventBus from '../../utils/EventBus'
import TabBar from './TabBar'
export default {
  components: { TabBar },
  props: {
    maxTabsToShow: {
      type: Number,
      default: 5
    },
    tabSetId: {
      type: String
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      selectedTab: 0,
      tabs: []
    }
  },
  beforeCreate () {
    EventBus.$on('register-tab', params => {
      if (this.tabSetId === params.tabSetId) {
        if (!this.tabs.find(tab => tab.id === params.id)) {
          if (!this.tabs.length) {
            this.selectedTab = params.id
            this.$emit('updateTabIndex', { index: 0 })
          }
          this.tabs.push(params)
          this.tabs = _.sortBy(this.tabs, ['position'])
        }
      }
    })

    EventBus.$on('unregister-tab', params => {
      const tabIndex = this.tabs.findIndex(tab => tab.id === params.id)
      if (tabIndex !== -1) {
        this.tabs.splice(tabIndex, 1)
      }
    })
  },
  computed: {
    divClass () {
      if (this.type === 'vertical') {
        return 'slds-vertical-tabs'
      } else if (this.type === 'default') {
        return 'slds-tabs_default'
      } else {
        return ''
      }
    }
  },
  methods: {
    clearTabErrors () {
      this.$refs.tabBar.clearTabErrors()
    },
    handleChangeTab (event) {
      const { tab } = event
      this.selectedTab = tab
      const selectedTabIndex = this.tabs.findIndex(t => t.id === tab)
      this.$emit('updateTabIndex', { index: selectedTabIndex })
      this.$emit('updateTabId', { id: tab })
    },
    handleChangeOverflowTab (event) {
      const { tab } = event
      this.selectedTab = tab
      const selectedTabIndex = this.tabs.findIndex(t => t.id === tab)
      this.$emit('updateTabIndex', { index: selectedTabIndex })
      this.$emit('updateTabId', { id: tab })
      const tempTab = this.tabs[selectedTabIndex]
      this.tabs[selectedTabIndex] = this.tabs[this.maxTabsToShow - 1]
      this.tabs[this.maxTabsToShow - 1] = tempTab
    },
    setActiveTab (index) {
      this.$refs.tabBar.setActiveTab(index)
    },
    setErrorTab (tabId, isError) {
      this.$refs.tabBar.setError(tabId, isError)
    }
  },
  watch: {
    selectedTab (tab) {
      this.$children.forEach(child => {
        if (child.tabId !== undefined) {
          child.show = child.tabId === tab
        }
      })
    }
  }
}
</script>
<template>
  <div :class="divClass" role="tablist">
    <TabBar
      ref="tabBar"
      :max-tabs-to-show="maxTabsToShow"
      :tabs="tabs"
      :selected-tab="selectedTab"
      :type="type"
      @changeTab="handleChangeTab"
      @changeOverflowTab="handleChangeOverflowTab" />

      <slot />
  </div>
</template>
